export default __webpack_public_path__ + "static/media/express-new.35e6848a.svg";